/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: InvoicesListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: InvoicesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';
import myGlobals = require('../globals');

import { InvoicesData, InvoicesService } from './Invoices.service';
import { InvoicesSearchComponent }  from './InvoicesSearch.component';

@Component({
	selector: 'my-Invoices',
	template: require('./InvoicesList.component.html'),
	providers: [InvoicesService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class InvoicesListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	InvoicesList: InvoicesData[];
	newInvoices: InvoicesData;
	selectedInvoices: InvoicesData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(InvoicesSearchComponent) filterComponent: InvoicesSearchComponent;

	sortExpression: string = "ShipName";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private InvoicesService: InvoicesService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newInvoices = new InvoicesData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		// this.InvoicesService.getAll().subscribe(record => this.InvoicesList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getInvoicesByPaging();

		/*
		this.InvoicesList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getInvoices() {
		this.InvoicesService.getAll()
			.subscribe(data => this.InvoicesList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on InvoicesSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getInvoicesByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getInvoicesByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getInvoicesByPaging();
	}
	
	// Get records by paging
	getInvoicesByPaging() {
		this.InvoicesService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.InvoicesList=data.InvoicesList;
				this.rowsCount=data.RowsCount; 
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}
	// Adds new record
	addInvoices() {
		this.InvoicesService.addInvoicesData(this.newInvoices).subscribe(record => console.log(record));
		this.getInvoices();
	}
  
	// Updates existing record
	updateInvoices() {
		this.InvoicesService.updateInvoicesData(this.selectedInvoices).subscribe(record => console.log(record));
		this.getInvoices();
	}

	// Deletes record with specified id
	deleteInvoices(id: string) {
		if (window.confirm('Are you sure you want to delete this Invoices?') == true)
		{
			this.InvoicesService.deleteInvoices(id)
			.subscribe(data => this.getInvoices(), 
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getInvoicesByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getInvoicesByPaging();
		}
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getInvoicesByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getInvoicesByPaging();
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// On Edit - Go to Edit page
	onSelect(item: InvoicesData) {
		this.router.navigate(['/Invoices', item.ShipName]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: InvoicesData) {
		this.router.navigate(['/Invoices/Details', item.ShipName]);
	}

	// Set record as selected
	SelectInvoices(item: InvoicesData) {
		this.selectedInvoices = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}

/*
	isSelected(item: InvoicesData) {
		return item.ShipName === this.selectedId;
	}
*/
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Invoices/InvoicesList.component.ts